import { z } from 'zod';
export const RealtimeEventTypeSchema = z.enum([
    'room:join',
    'room:leave',
    'room:message',
    'presence:update',
    'notification:new',
]);
export const RealtimeMessageSchema = z.object({
    event: RealtimeEventTypeSchema,
    room: z.string().optional(),
    data: z.unknown(),
    timestamp: z.string().datetime().optional(),
});
export const PresenceStatusSchema = z.enum(['online', 'offline', 'away', 'typing']);
export const PresenceUpdateSchema = z.object({
    userId: z.string(),
    status: PresenceStatusSchema,
    lastSeen: z.string().datetime().optional(),
});
//# sourceMappingURL=events.js.map